import { apiClient, apiDelete, apiFetch } from '@/utils/fetchWrapper';
import type {
  AccessibleVoicemailMailbox,
  GroupVoicemailMessage,
  VoicemailMessage,
} from '@/types/voicemail';

export const voicemailService = {
  async listVoicemails(): Promise<VoicemailMessage[]> {
    const data = await apiFetch<VoicemailMessage[]>('/voicemail/');
    return Array.isArray(data) ? data : [];
  },

  async listAccessibleMailboxes(): Promise<AccessibleVoicemailMailbox[]> {
    const data = await apiFetch<AccessibleVoicemailMailbox[]>(
      '/group-voicemail-mailboxes/accessible/'
    );
    return Array.isArray(data) ? data : [];
  },

  async listGroupVoicemails(mailboxId: string): Promise<GroupVoicemailMessage[]> {
    const data = await apiFetch<GroupVoicemailMessage[]>(
      `/group-voicemail-mailboxes/${mailboxId}/messages/`
    );
    return Array.isArray(data) ? data : [];
  },

  async listDeletedVoicemails(): Promise<VoicemailMessage[]> {
    const data = await apiFetch<VoicemailMessage[]>('/voicemail/deleted/');
    return Array.isArray(data) ? data : [];
  },

  /**
   * Loads WAV bytes with JWT auth (plain audio src cannot send Bearer tokens).
   */
  async listNominalVoicemails(nominalId: string): Promise<VoicemailMessage[]> {
    const data = await apiFetch<VoicemailMessage[]>(
      `/nominals/${nominalId}/voicemails/`
    );
    return Array.isArray(data) ? data : [];
  },

  async fetchNominalVoicemailAudio(nominalId: string, uuid: string): Promise<Blob> {
    const response = await apiClient.get<Blob>(
      `/nominals/${nominalId}/voicemails/${uuid}/audio/`,
      { responseType: 'blob' }
    );
    return response.data;
  },

  async fetchVoicemailAudio(uuid: string): Promise<Blob> {
    const response = await apiClient.get<Blob>(`/voicemail/${uuid}/audio/`, {
      responseType: 'blob',
    });
    return response.data;
  },

  async fetchGroupVoicemailAudio(mailboxId: string, uuid: string): Promise<Blob> {
    const response = await apiClient.get<Blob>(
      `/group-voicemail-mailboxes/${mailboxId}/messages/${uuid}/audio/`,
      {
        responseType: 'blob',
      }
    );
    return response.data;
  },

  async deleteVoicemail(uuid: string): Promise<void> {
    await apiDelete(`/voicemail/${uuid}/`);
  },

  async deleteGroupVoicemail(mailboxId: string, uuid: string): Promise<void> {
    await apiDelete(`/group-voicemail-mailboxes/${mailboxId}/messages/${uuid}/`);
  },
};
